module.exports = __webpack_public_path__ + "img/download.6ceb9954.png";